<template>
  <v-dialog v-model="dialog" persistent width="950">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id_puesto ? "edit" : "add" }}</v-icon>
          {{ form.id_puesto ? "Modificar Puesto" : "Crear Puesto" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario --> 
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md12 xs12>
                <v-text-field
                  label="Puesto"
                  v-model="form.denominacion"
                  :rules="$validate(['required'])"
                  required
                  
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
    };
  },
  mounted() {
    this.$bus.$on("openDialogCrearActualizarPuestos", (item) => {
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.$bus.$emit("closeDialogCrearActualizarPuestos");
      this.dialog = false;
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let user = this.$storage.get("user");
        try {
			this.form.denominacion=this.form.denominacion.toUpperCase()
          if (this.form.id_puesto) {
            //edito puesto
            let respuesta = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select movilidad.fn_actualiza_puesto(${parseInt(
                  this.form.id_puesto
                )} ,'${this.form.denominacion}',${parseInt(user.id)})"){
                  respuesta
                }
              }
            `,
            });
            respuesta =
              respuesta.runQuery.respuesta[0].fn_actualiza_puesto.split("|");
            if (respuesta[0] == "1") {
              this.$message.success("Registro modificado exitosamente");
            } else {
              this.$message.warning(respuesta[1]);
            }
          } else {
            //creo nuevo puesto
            let respuesta = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select movilidad.fn_registra_puesto('${
                  this.form.denominacion
                }',${parseInt(user.id)})"){
                  respuesta
                }
              }
            `,
            });
            respuesta =
              respuesta.runQuery.respuesta[0].fn_registra_puesto.split("|");
            if (respuesta[0] == "1") {
              this.$message.success("Registro creado exitosamente");
            } else {
              this.$message.warning(respuesta[1]);
            }
          }
        } catch (error) {
          console.log(error);
        }
        this.$message.success();
        this.loading = false;
        this.close();
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/admin/item_cargo_y_puesto/dialogs/CrearActualizarPuestos.vue